<template>
  <div class="sign-up-container">
    <proa-card flat class="sign-up-card">
      <div class="tab-wrapper">
        <div class="active">{{ $t('common.signUp') }}</div>
        <div>
          <router-link :to="{ name: 'signIn' }">{{ $t('common.signIn') }}</router-link>
        </div>
      </div>
      <div class="form-wrapper">
        <router-link :to="{ name: 'root' }" class="d-block mb-4 pb-2">
          <img :src="require('@/assets/images/logo.png')" class="logo"/>
        </router-link>
        <div class="mb-4 pb-2 font-weight-w6">{{ $t('common.createNewAccount') }}</div>
        <validation-observer v-slot="{ handleSubmit }">
          <form novalidate @submit.prevent="() => { validated = true; handleSubmit(onSubmitSignUp) }">
            <div class="mb-4">
              <validation-provider
                :name="$t('models.user.attributes.email')"
                rules="required|email"
                v-slot="{ errors }"
              >
                <proa-input-group :invalidFeedback="validated ? invalidEmail ? $t('pages.signUp.invalidEmailMessage') : errors[0] : null">
                  <template slot="input">
                    <proa-input
                      v-model="email"
                      type="email"
                      :placeholder="$t('models.user.attributes.email')"
                      :disabled="signUpRequesting"
                      dark
                      @input.native="invalidEmail = false"
                    />
                  </template>
                </proa-input-group>
              </validation-provider>
            </div>
            <div class="name-fields">
              <validation-provider
                :name="$t('models.user.attributes.lastName')"
                rules="required"
                v-slot="{ errors }"
              >
                <proa-input-group :invalidFeedback="validated ? errors[0] : null">
                  <template slot="input">
                    <proa-input
                      v-model="lastName"
                      type="text"
                      :placeholder="$t('models.user.attributes.lastName')"
                      :disabled="signUpRequesting"
                      dark
                    />
                  </template>
                </proa-input-group>
              </validation-provider>
              <validation-provider
                :name="$t('models.user.attributes.firstName')"
                rules="required"
                v-slot="{ errors }"
              >
                <proa-input-group :invalidFeedback="validated ? errors[0] : null">
                  <template slot="input">
                    <proa-input
                      v-model="firstName"
                      type="text"
                      :placeholder="$t('models.user.attributes.firstName')"
                      :disabled="signUpRequesting"
                      dark
                    />
                  </template>
                </proa-input-group>
              </validation-provider>
            </div>
            <div class="mt-2 mb-4">
              <confirm-terms-check-box
                :agreedTerms="agreedTerms"
                @onChange="agreedTerms = !agreedTerms"
              />
            </div>
            <div class="py-2 mb-4">
              <proa-button
                class="w-100"
                type="submit"
                variant="primary"
                :disabled="!agreedTerms"
                :loading="signUpRequesting"
              >
                {{ $t('common.createNewAccount') }}
              </proa-button>
            </div>
            <div class="pt-1">
              <router-link :to="{ name: 'resendConfirmation' }">{{ $t('pages.signUp.resendConfirmation') }}</router-link>
            </div>
          </form>
        </validation-observer>
      </div>
    </proa-card>
    <proa-modal
      :modal="confirmMailSentModal"
      :title="$t('pages.signUp.confirmMailSentModal.title')"
      @close="$router.push({ name: 'service' })"
      hideCloseButton
    >
      <div class="text-pre-wrap">
        <span class="font-weight-w6 text-secondary mr-2">{{ email }}</span>
        <span>{{ $t('pages.signUp.confirmMailSentModal.body') }}</span>
      </div>
    </proa-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ConfirmTermsCheckBox from '@/components/molecules/ConfirmTermsCheckBox'

export default {
  name: 'SignUp',
  components: {
    ConfirmTermsCheckBox
  },
  data () {
    return {
      email: '',
      lastName: '',
      firstName: '',
      signUpRequesting: false,
      validated: false,
      invalidEmail: false,
      confirmMailSentModal: false,
      agreedTerms: false
    }
  },
  computed: {
    ...mapGetters({
      httpError: 'httpError'
    })
  },
  methods: {
    async onSubmitSignUp() {
      this.signUpRequesting = true
      await this.signUp({
        email: this.email,
        lastName: this.lastName,
        firstName: this.firstName
      })
      this.signUpRequesting = false

      if (this.httpError) {
        if (this.httpError.response?.status == 422) {
          this.invalidEmail = true
        }
      } else {
        this.confirmMailSentModal = true
      }
    },
    ...mapActions({
      signUp: 'auth/signUp'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.sign-up-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sign-up-card {
  width: 100%;

  @include mq(sm) {
    width: 400px;
  }
}

.invalid-email-message {
  display: flex;
  justify-content: center;
  white-space: nowrap;
  font-size: 13px;
  color: $error-color;
}

.name-fields {
  display: flex;

  span:first-child {
    display: block;
    margin-right: 10px;
  }
}

.tab-wrapper {
  width: 100%;
  height: 50px;
  display: flex;

  div {
    flex-basis: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $light-gray-color;
    font-size: 16px;
    font-weight: 600;

    &.active {
      background-color: white;
      color: $primary-color;
    }

    a {
      color: $light-text-color;
      text-decoration: none;
    }
  }
}

.form-wrapper {
  padding: 40px 50px;
  text-align: center;

  .logo {
    width: 150px;
  }
}

</style>
